var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(!_vm.$route.meta.hideToolbars)?[(_vm.checkOnBauerBiz)?_c('PlanningToolbar'):_vm._e(),_c('PlanningHeader')]:_vm._e(),_c('KeepAlive',[_c('RouterView')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }